import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import NoData from '../../../components/NoData/NoData';
import { setChart } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData } from '../CTHActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';

import CTHChart from './../components/CTHChart';
import AvgCycleTime from './../components/AvgCycleTime';
import DetailsAccordion from '../../../components/DetailsAccordion/CTHDetailsAccordion';

import { 
  trackTeamDashboardView, 
  trackChartPointDetailsView,
  trackHowToOpened 
} from '../../../util/mixpanel';

import './../CTH.scss';

class CTH extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };

    this.handleChange = this.handleChange.bind(this);

    props.dispatch(setPageName('Cycle time histogram'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('cth');

      trackTeamDashboardView('cth');
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash || prevProps.hash != this.props.hash) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    } else if (prevProps.timeUnit !== this.props.timeUnit) {
      this.setState({
        selectedPoint: {}
      });
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.dataIsLoading != this.props.dataIsLoading && newProps.dataIsLoading === false) {
      this.handleChange(true);
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.setState({
        selectedPoint: {}
      });
      this.props.getData();
    }
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });

    trackChartPointDetailsView('cth', true);
  };

  trackHowToCTHOpen() {
    trackHowToOpened('cth');
  }

  trackHowToCTDOpen() {
    trackHowToOpened('ctd');
  }

  render() {
    const totalItems = !this.props.data ? 0 : _.reduce(this.props.data.series, (p, c) => {
      return p + (c.data && c.data.length || 0);
    }, 0);

    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <p>Use the chart to:</p>
          <ul>
            <li>Analyze your cycle time distribution</li>
            <li>Monitor your delivery performance</li>
            <li>Forecast task delivery times</li>
          </ul>
          <a
            href={`https://getnave.com/cycle-time-histogram`}
            target="_blank"
            onClick={this.trackHowToCTHOpen}
            onAuxClick={this.trackHowToCTHOpen}
            className='btn btn-secondary'
            >
              Learn more
          </a>
        </div>
      </div>
    );

    return (
      <div className="content-wrap">
        <Helmet>
          <title>{pageTitle(`Cycle Time Histogram${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`)}</title>
        </Helmet>
        <Filter totalItems={totalItems} showAvgChart enableMarkBlocked enablePercentiles navigator timeunit dateformat />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>
                Cycle Time Histogram
              </h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              <Options showNavigator showAvgChart options={{ avgChartTooltip: 'Cycle Time Averages' }} />
              <DatePicker />
            </div>
          </div>
          <div className="dashboard_details">
            {this.props.data.series && !!this.props.data.series.length && this.props.avgChart && (
              <AvgCycleTime data={this.props.data.series} dateFormat={this.props.dateFormat} widget="act" />
            )}
            <DetailsAccordion id="details-accordion" data={this.state.selectedPoint} blockedTime={this.props.blockedTime} blockers={this.props.blockers} />
          </div>
          {this.props.isFatTailed !== undefined && (
            <div
              style={{
                marginLeft: '40px',
                marginTop: '-20px'
              }}
            >
              <span>
                {this.props.isFatTailed ? 'Fat-Tailed Distribution' : 'Thin-Tailed Distribution'}{' '}
                {/*<OverlayTrigger
                  delay={{ show: 250, hide: 2000 }}
                  placement="top"
                  overlay={
                    <Tooltip id="flowstats-tooltip" className="tooltip_white">
                      How to use{' '}
                      <a
                        href={`https://getnave.com/blog/thin-tailed-vs-fat-tailed-distribution/`}
                        target="_blank"
                        onClick={this.trackHowToCTDOpen}
                        onAuxClick={this.trackHowToCTDOpen}
                      >
                        Cycle Time Distribution
                      </a>
                    </Tooltip>
                  }
                  delayHide={2000}
                >
                  <span className="more_info"></span>
                </OverlayTrigger>*/}
              </span>
            </div>
          )}
          <div className="diagram_details">
            <CTHChart id="CTH" data={this.props.data} onPointClick={this.handlePointClick} />
            <NoData
              show={this.props.data.series && !this.props.data.series.length}
              loading={this.props.detailsIsLoading || this.props.isLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData())
  };
};

const mapStateToProps = state => {
  const customFields = _.map(state.filters.allCustomFields, cf => {
    return state.filters.cth[`selected${cf}`];
  });

  return {
    dateFormat: state.filters.dateFormat,
    hash: state.filters.cth.hash,
    avgChart: state.filters.cth.avgChart,
    timeUnit: state.filters.cth.timeUnit,
    blockedTime: state.filters.ctsp.blockedTime,
    blockers: state.filters.cth.blockers,
    data: state.cth.data,
    isLoading: state.cth.isLoading,
    detailsIsLoading: state.cth.detailsIsLoading,
    isFatTailed: state.cth.isFatTailed,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,
    customFields,
    app: state.app.app
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CTH);
